const payloadCreateBlast = () => ({
	judul: "",
	idoutlet: null,
	iddevice: [],
	idtemplate: [],
	namaTemplate: [],
	interval: 40,
	filter_customer: {
		key: "",
		filter_by: "",
		tahun: "",
		bulan: "",
		tanggal_awal: "",
		tanggal_akhir: "",
		filter_kolom: null,
		filter_layanan_by: "",
		idlayanan_array: [],
		iddeposit_array: [],
		outlet_array: [],
	}
})

export default payloadCreateBlast